import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { classNamesConfig } from "../../../features/classnames";
import { Block } from "../../Container";
import { VideoComponent } from "../../Video/VideoComponent";
export const VideoBlock = (props)=>{
    const video = props.video;
    if (!video.Url) {
        console.warn("VideoBlock rendered without Url");
        return /*#__PURE__*/ _jsx(_Fragment, {});
    }
    const blockClassNames = classNamesConfig().media;
    return /*#__PURE__*/ _jsx(Block, {
        children: /*#__PURE__*/ _jsx("figure", {
            className: `block block--video block--media ${blockClassNames.block}`,
            children: /*#__PURE__*/ _jsx("div", {
                className: `block__inner ${blockClassNames.inner}`,
                children: /*#__PURE__*/ _jsx("div", {
                    className: `block__visual block__video ${blockClassNames.visual}`,
                    children: /*#__PURE__*/ _jsx(VideoComponent, {
                        video,
                        showAcceptCookiesButton: true
                    })
                })
            })
        })
    });
};
{}